import DataTable from "components/data-table/data-table";
import { TableColumn } from "components/table/table";
import { apply, currencyFormat } from "core/utils";
import { useCallback } from "react";
import { ActionHandler, ObjectIndex } from "types";
import { LightButton } from "../../../../components/buttons/buttons";
import { PagoRealizadoRespuesta } from "../types/pagos.types";

const columns: TableColumn[] = [
	{ key: "idCobro", title: "ID de Cobro" },
	{ key: "concepto", title: "Concepto de Pago" },
	{ key: "importe", title: "Importe", tdStyle: { textAlign: "right" } },
	{ key: "estatus", title: "Estatus de Pago" },
	{ key: "fechaPago", title: "Fecha de Pago" },
	{ key: "acciones", title: "", tdStyle: { width: 350 } }
];

type PagosRealizadosTableProps = {
	loading?: boolean;
	registros: PagoRealizadoRespuesta[];
	verComprobante: ActionHandler<PagoRealizadoRespuesta>;
};

const PagosRealizadosTable = ({ loading, registros, verComprobante }: PagosRealizadosTableProps) => {
	const mostrarAcciones = useCallback((column: TableColumn, registro: PagoRealizadoRespuesta & ObjectIndex) => {
		if (column.key === "importe") {
			return currencyFormat(registro[column.key]);
		}

		if (column.key === "acciones") {
			if (registro.estatus === "Realizado" || registro.estatus === "Pago duplicado") {
				return <LightButton disabled={loading} onClick={apply(verComprobante, registro)}>Ver comprobante</LightButton>
			}
		}

		return registro[column.key];
	}, [loading, verComprobante]);

	return (
		<DataTable columns={columns} items={registros} onRenderItem={mostrarAcciones} />
	);
};

export default PagosRealizadosTable;